// SAM-624 — the picked service, re-read from `GET /services/description/{id}` so the booking flow
// prices against what the guest app sees (see bookingService.ts). `service` is null until that
// response arrives, so nothing can be built from the raw list row in the meantime.

import { useMemo } from 'react';
import { useServiceById, type Service } from '../../../hooks/useServices';
import { mergeServiceDetail, type BookingService, type ServiceDetail } from './bookingService';

export function useBookingService(service: Service | null | undefined) {
  const query = useServiceById(service?.id);
  const merged = useMemo<BookingService | null>(
    () => (service && query.data ? mergeServiceDetail(service, query.data as ServiceDetail) : null),
    [service, query.data]
  );
  return { service: merged, isLoading: query.isLoading, error: query.error as Error | null };
}
